import { useEffect, FunctionComponent } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { setUserRolesModalIsOpen, setSignUpModalIsOpen } from 'redux/actions'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const Forbidden: FunctionComponent = () => {
  const dispatch = useDispatch()
  const isLogged = useSelector(selectIsLogged)

  useEffect(() => {
    dispatch(isLogged
      ? setUserRolesModalIsOpen(true)
      : setSignUpModalIsOpen(true)
    )
  }, [isLogged])

  return <span />
}

export default Forbidden
